"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniProviderBookAndReferList = void 0;
var MiniProviderBookAndReferList_1 = require("./MiniProviderBookAndReferList");
Object.defineProperty(exports, "MiniProviderBookAndReferList", { enumerable: true, get: function () { return __importDefault(MiniProviderBookAndReferList_1).default; } });
//# sourceMappingURL=index.js.map